import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components/macro'
import { Link, useLocation } from 'react-router-dom'
import { Icon, Header } from '../components/layout'

const SecondaryNav = styled('div')`
  width: 240px;
`

const Head = styled('div')`
  padding: 20px;
`

const Title = styled('h1')`
  padding: 0;
  margin: 0;
  font-size: 20px;
  font-weight: bold;
`

const Navbar = styled('div')`
  display: flex;
  flex-direction: column;
`

const NavLink = styled(Link)`
  display: flex;
  flex-direction: row;
  text-decoration: none !important;
`

const NavItem = styled('div')`
  background: ${(props) => (props.isActive ? props.theme.backgroundColors.lightergray : 'transparent')};
  padding: 2px 20px;
  border-top-right-radius: ${(props) => props.theme.borderRadius.large};
  border-bottom-right-radius: ${(props) => props.theme.borderRadius.large};

  ${NavLink} {
    color: ${(props) => (props.isActive ? props.theme.colors.primary : props.theme.textColors.default)};
    text-decoration: none !important;
  }

  :hover {
    ${NavLink} {
      color: ${(props) => (props.isActive ? props.theme.colors.primary : props.theme.textColors.default)};
    }
  }
`

const LinkText = styled('div')`
  padding: 7px 10px;
`

const AdvanceNav = () => {
  const { pathname } = useLocation()

  return (
    <Header collapsed={false}>
      <SecondaryNav>
        <Head>
          <Title>
            <FormattedMessage id="nav.advances" />
          </Title>
        </Head>
        <Navbar>
          <NavItem isActive={pathname === '/advances'}>
            <NavLink to="/advances">
              <Icon name="GridViewSmall" size="lg" />
              <LinkText>
                <FormattedMessage id="nav.advances_all" />
              </LinkText>
            </NavLink>
          </NavItem>
          <NavItem isActive={pathname.includes('/balances')}>
            <NavLink to="/advances/balances">
              <Icon name="Bank" size="lg" />
              <LinkText>
                <FormattedMessage id="nav.advances_balances" />
              </LinkText>
            </NavLink>
          </NavItem>
        </Navbar>
      </SecondaryNav>
    </Header>
  )
}

export default AdvanceNav
